import _ from "lodash"

import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"
import { FieldsBehaviour } from "@csrc/assets/data/constants/FieldsBehaviour"
import { SimpleRuleItem } from "@cmodules/checklist/assets/data/types/vm/template-builder/simple-rule"

export type BehaviouralRuleType =
  typeof FieldsBehaviour[keyof typeof FieldsBehaviour]['behaviouralRuleType'];

export class AssetFieldOptionsVM extends CommonOptionVM {
  required?: boolean;
  editable?: boolean;
  manual_rating?: boolean;
  hidden?: boolean;
  asset_type_uuid?: string;
  asset_type_id?: number;
  field_key?: string; // *** default value from form is set to ""
  field_type?: keyof typeof FieldsBehaviour;
  value_type?: BehaviouralRuleType
  simple_rule?: SimpleRuleItem[]


  constructor(data: Partial<AssetFieldOptionsVM> = {}) {
    super(data)
    this.required = data.required || undefined
    this.editable = data.editable || undefined
    this.manual_rating = data.manual_rating || undefined
    this.hidden = data.manual_rating || undefined
    this.asset_type_uuid = data.asset_type_uuid || undefined
    this.asset_type_id = data.asset_type_uuid ? (data.asset_type_id ?? undefined) : undefined
    this.field_key = data.field_key || undefined
    this.field_type = data.field_key ? this.field_type : undefined
    this.value_type = data.field_key && this.field_type ? FieldsBehaviour[this.field_type].behaviouralRuleType : undefined
    this.simple_rule = data.simple_rule ? _.map(data.simple_rule, x => new SimpleRuleItem(x as any)) : undefined
  }

  validateData() {
    const errors: any[] = []
    if (this.asset_type_uuid && !this.asset_type_id) {
      errors.push({ key: 'asset_type_id', error_message: 'Asset type id must not be empty when Asset type is not empty' })
    }

    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default AssetFieldOptionsVM